import { Component, OnInit } from '@angular/core';
import { AuthProxyService } from 'src/app/shared/authentication/auth-proxy.service';
import { sleep } from 'src/util/async';

@Component({
  selector: 'fl-logout',
  template: '<div>Logging out....</div>',
})
export class LogoutPageComponent implements OnInit {
  constructor(private _authProxy: AuthProxyService) {}

  public async ngOnInit() {
    // give enough time for logout navigation to be logged before redirecting
    await sleep(500).then(() => this._authProxy.logout({ redirectUrl: '/' }));
  }
}
